// store/updateWebinarSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = "https://api-workshop.firststepoverseas.com/webinars";

export const updateWebinar = createAsyncThunk(
  "webinars/updateWebinar",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("access");
      const formData = new FormData();

      // append all non-null values
      Object.entries(data).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "image") {
          formData.append(key, value);
        }
      });

      // only append image if a new file is selected
      if (data.image instanceof File) {
        formData.append("image", data.image);
      }

      const response = await axios.patch(`${API_URL}/${id}/`, formData, {
        headers: {
          Authorization: `JWT ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Update error:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const updateWebinarSlice = createSlice({
  name: "updateWebinar",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetUpdateState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateWebinar.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateWebinar.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updateWebinar.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateState } = updateWebinarSlice.actions;
export default updateWebinarSlice.reducer;
